// src/features/layout/entityPanels.tsx
// Registry of entity panels — the rail tabs (Discussion, Tasks, Schedule, …)
// that any detail page gets for free once it puts its entity into context
// (entityStore.loadEntityData). Features register their panels at import time;
// the Right Rail appends them after its built-in tabs.
//
// Plain module-level array, no MobX: registrations happen once at import time
// and never change for the life of the page, so there is nothing to observe.

export interface EntityPanelEntity {
  id: string;
  type_name: string;
}

export interface EntityPanelProps {
  entity: EntityPanelEntity;
  /** Display title of the entity in context (conversation name, headings). */
  title?: string;
}

export interface EntityPanelDef {
  key: string;
  icon: React.FC<{ className?: string }>;
  labelKey: string;
  component: React.ComponentType<EntityPanelProps>;
  /** Entity types the panel applies to; undefined means every type. */
  appliesTo?: string[];
  /** Entity types for which the feature is unavailable. */
  excludesTypes?: string[];
}

const panels: EntityPanelDef[] = [];

export function registerEntityPanel(def: EntityPanelDef): void {
  if (panels.some((p) => p.key === def.key)) return;
  panels.push(def);
}

export function getEntityPanels(): EntityPanelDef[] {
  return panels;
}
